import { Navigate, Outlet, useSearchParams } from 'react-router'
import { useAppSelector } from 'universal-scripts'
import { getPricingPath, isPlanId } from 'src/constants/plans'

export default function RequireGuest() {
  const isLoggedIn = useAppSelector((state) => !!state.user)
  const [searchParams] = useSearchParams()

  if (isLoggedIn) {
    if (__SERVER__) {
      return null
    }

    const plan = searchParams.get('plan')
    const to = isPlanId(plan) ? `/${getPricingPath(plan)}` : '/'

    return <Navigate to={to} replace />
  }

  return <Outlet />
}
